import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchCategoryWiseProductAPI } from "./categoryWiseProductAPI";

export const fetchCategoryWiseProduct = createAsyncThunk(
    "product/fetchCategoryWiseProduct",
    async (id) => {
        const data = await fetchCategoryWiseProductAPI(id);
        return data
    }
)

const categoryWiseProductSlice = createSlice({
    name: "categoryWiseProductData",
    initialState: {
        category_details: {},
        loading: false,
        error: null
    },

    reducers: {},

    extraReducers: (builder) => {
        builder
        .addCase(fetchCategoryWiseProduct.pending, (state) => {
            state.loading = true;
        })
        .addCase(fetchCategoryWiseProduct.fulfilled, (state, action) => {
            state.loading = false;
            state.category_details = action.payload.data || {};
        })
        .addCase(fetchCategoryWiseProduct.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        })
    }
})

export default categoryWiseProductSlice.reducer;